import { Component } from '@angular/core';

import { BaseScorecardComponent } from '../base/_base-scorecard.component';


@Component({
  moduleId: module.id,
  selector: 'marketing-scorecard',
  templateUrl: 'marketing-scorecard.component.html',
})
export class MarketingScorecardComponent extends BaseScorecardComponent {
  segmentTitle: string = 'Market Copy';
  segmentData: any = {};
}
